import { render, staticRenderFns } from "./ListAds2.vue?vue&type=template&id=43da63c1&scoped=true"
import script from "./ListAds2.vue?vue&type=script&lang=js"
export * from "./ListAds2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43da63c1",
  null
  
)

export default component.exports